import React from 'react';
import './Logo.css';

const Logo = ({ size = 'medium', variant = 'full', animated = false, className = '' }) => {
  const sizeClasses = {
    small: 'logo-small',
    medium: 'logo-medium',
    large: 'logo-large',
    xlarge: 'logo-xlarge'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.medium;

  return (
    <div className={`arcvpn-logo ${sizeClass} ${variant} ${animated ? 'animated' : ''} ${className}`}>
      <div className="logo-icon-wrapper">
        <svg 
          viewBox="0 0 48 48" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="logo-icon"
        >
          <defs>
            {/* Premium gradient */}
            <linearGradient id="arcGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0F9B8E" />
              <stop offset="100%" stopColor="#0B7A70" />
            </linearGradient>
          </defs>
          
          {/* Background hexagon - premium shape */}
          <path
            d="M24 4 L42 14 L42 34 L24 44 L6 34 L6 14 Z"
            fill="url(#arcGradient)"
            className="hex-bg"
          />
          
          {/* Inner hexagon outline */}
          <path
            d="M24 8 L38 16 L38 32 L24 40 L10 32 L10 16 Z"
            fill="none"
            stroke="rgba(255,255,255,0.2)"
            strokeWidth="0.5"
            className="hex-inner"
          />
          
          {/* Arc/Letter A stylized */}
            <path
            d="M24 14 L32 30 L29 30 L27.5 26 L20.5 26 L19 30 L16 30 L24 14 Z M24 18 L21.5 24 L26.5 24 L24 18 Z"
            fill="white"
            className="letter-a"
          />
        </svg>
      </div>
      
      {variant !== 'icon' && (
        <div className="logo-text-wrapper">
          <span className="logo-text">
            <span className="logo-text-arc">Arc</span>
            <span className="logo-text-vpn">VPN</span>
          </span>
          {variant === 'full-tagline' && (
            <span className="logo-tagline">Secure • Private • Fast</span>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
